// extracted by css-extract-rspack-plugin
export default {"visualization":"KKeCr","nonClickable":"DY0x1"};